export const NotificationArea = () => (
  <div
    className="arx-corporate-header__slot"
    data-aranox-slot="notifications"
    aria-label="Área reservada para notificações"
  >
    <span
      className="arx-corporate-header__slot-indicator"
      aria-hidden="true"
    />
    <span>Notificações</span>
  </div>
);
